import { AbsoluteLayout, GridLayout } from '@splunk/dashboard-layouts';
import type { PresetMap } from '@splunk/dashboard-types';

import datasourcePresets from './DatasourcePresets';
import eventHandlerPresets from './EventHandlerPresets';
import inputPresets from './InputPresets';
import vizPresets from './VisualizationPresets';
import { NOPVisualizationFactory } from './utils/NOPVisualizationFactory';

export default {
    layouts: {
        absolute: AbsoluteLayout,
        grid: GridLayout,
    },
    ...datasourcePresets,
    ...eventHandlerPresets,
    ...inputPresets,
    // Remap the visualization preset to only render empty div elements
    visualizations: Object.fromEntries(
        Object.keys(vizPresets.visualizations).map((key) => [
            key,
            NOPVisualizationFactory(key),
        ])
    ),
} as PresetMap;
